import services from './../../../services/service'; // Service Class
import validation from './../../../services/validation'; // Validation
// import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer
import LogoPad from '../../../components/templates/logo-pad.vue'
import AccountDropMenu from '../../../components/templates/account-menu.vue'

import ProductForm from '../../../components/product/ProductForm.vue'

let service = new services();
let validator = new validation();
export default {
    name: 'SellpointTemplate',
    data () {
        return {
            path: (this.$route.path).replace('/',''),
            path_name: this.$route.name,
            sellpoint_name:(this.$route.path).split('/')[1],
            product_name:(this.$route.path).split('/')[2],
        }
    },
    components: {
        'logo-pad': LogoPad,
        'component-account-menu': AccountDropMenu,
        'component-footer': MainFooter,
        'product-form': ProductForm
     },
    methods: {
        back(){
            window.history.back();
        },
        setPageHeaders(){
            // When the user scrolls the page, execute setStickyHeader
            window.onscroll = function() {
                // Get the header
                var stick_header = document.getElementById("pageStickyHeader");
    
                // Get the offset position of the navbar
                var sticky = stick_header.offsetTop;
    
                // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
                if (window.pageYOffset > sticky) {
                    stick_header.classList.add("header-sticky-after");
                } else {
                    stick_header.classList.remove("header-sticky-after");
                }
            };
        },
    
        setStickyHeader() {
            // Get the header
            var stick_header = document.getElementById("pageStickyHeader");
    
            // Get the offset position of the navbar
            var sticky = stick_header.offsetTop;
    
            // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
            if (window.pageYOffset > sticky) {
                stick_header.classList.add("header-sticky-after");
            } else {
                stick_header.classList.remove("header-sticky-after");
            }
        }
    },
    created: function(){
        if(this.path_name == 'Sellpoint'){this.setPageHeaders();} //for sellpoint only
    }
}


// WEBPACK FOOTER //
// ./src/pages/Sellpoint/SellpointTemplate/script.js